export const smallest = 4;
export const smaller = 8;
export const small = 12;
export const regular = 16;
export const large = 24;
export const larger = 32;
export const largest = 48;
export const loose = 56;
export const looser = 64;
export const loosest = 80;
